import React from "react";

import Box from "@mui/joy/Box";
import {CircularProgress, Stack,} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";

import {
    applyEdgeChanges,
    applyNodeChanges,
    Background,
    BaseEdge,
    Controls,
    MiniMap,
    ReactFlow,
} from "reactflow";
import 'reactflow/dist/style.css';

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import BaseApi from "../../utils/BaseApi";
import SelfConnectingEdge from "../Admin/SelfConnectingEdge";
import AgentNode from "./AgentNode";
import withRouter from "../../utils/withRouter";
import {CommonJSONField} from "../Common/CommonJSONFieldForm";
import CommonCallBackButton from "../Common/CommonCallBackButton";

// icons
import GetAppIcon from '@mui/icons-material/GetApp';
import CommonEditModal from "../Common/CommonEditModal";

const nodeTypes = {
    mainNode: AgentNode,
};
const edgeTypes = {
    selfconnecting: SelfConnectingEdge,
    baseEdge: BaseEdge,
};


class AgentDetail extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            edges: null,
            nodes: null,
            agentNodes: null,
            agent: null,
            isLoading: true,
        };
    }

    async componentDidMount() {
        await this.retrieveAgentNodes();

        await setTimeout(() => {
          this.setState({isLoading: false});
        }, 2000);
    }



    async retrieveAgentNodes(){
        await this.setState(
            {
                agentNodes: null,
            }
        );
        let url = `agent_node/`;
        const api = new BaseApi();
        const params = {
            agent: this.props.params.agentId,
            page_size: 10000,
        };
        let response = await api.get(url, params);
        let agentNodes = response.data.results
        let rawNodes = agentNodes.map((node) => {
            return(
                {
                    id: `${node.id}`,
                    position: {
                        x: node.x_coordinate,
                        y: node.y_coordinate,
                    },
                    data: {
                        label: node.title,
                        obj: node,
                        callBack: this.retrieveAgentNodes.bind(this)
                    },
                    width: 300,
                    height: 300,
                    type: 'mainNode',
                    dragHandle: '.custom-drag-handle',
                }
            )
            }
        );
        let rawEdges = [];
        for (let node of agentNodes) {
            if (node.next_step){
                rawEdges.push(
                    {
                        id: `${node.id}-${node.next_step}`,
                        source: `${node.id}`,
                        target: `${node.next_step}`,
                        style: { stroke: '#fff' },
                        markerEnd: {
                            type: "arrowclosed"
                        },
                        type: 'selfconnecting',
                    }
                )
            }

        }
        url = `agent/${this.props.params.agentId}`
        response = await api.get(url, {});
        await this.setState(
            {
                nodes: rawNodes,
                edges: rawEdges,
                agentNodes: agentNodes,
                agent: response.data
            }
        );
    }

    async onNodesChange(changes) {
        if (changes){
            for (const change of changes){
                if (change.type === 'position' && change.dragging){
                    const url = `agent_node/${change.id}/`;
                    const api = new BaseApi();
                    const data = {
                        x_coordinate: Math.ceil(change.position.x),
                        y_coordinate: Math.ceil(change.position.y),
                    }
                    await api.patch(url, data);
                }
            }
        }
        this.setState(
            {
                nodes: applyNodeChanges(changes, this.state.nodes)
            }
        );
    }

    onEdgesChange(changes) {
        this.setState(
            {
                edges: applyEdgeChanges(changes, this.state.edges)
            }
        );
    }

    async onSubmit(event) {
        event.preventDefault();
        let formDataObj = Object.fromEntries(
            (new FormData(event.currentTarget)).entries()
        );
        for (const [key, value] of Object.entries(formDataObj)) {
            formDataObj[key] = JSON.parse(value)
        }
        const url = `agent/${this.state.agent.id}/`;
        const api = new BaseApi();
        await api.patch(
            url,
            formDataObj
        );
    }

    async export() {
        let url = `agent/${this.props.params.agentId}/export_agent/`;
        const api = new BaseApi();
        const params = {};
        let response = await api.get(url, params);
        let data = response.data

        const blob = new Blob([data], {type: 'application/json'});
        const jsonUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = jsonUrl;
        link.download = `export.json`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(jsonUrl);
    }

    render() {
        if (!this.state.agentNodes || !this.state.agent){
            return (<CircularProgress/>)
        }
        if (!this.state.nodes || !this.state.edges || this.state.isLoading){
            return (<CircularProgress/>)
        }
        return(
            <Stack>
                <Stack
                    direction={'row'}
                    spacing={2}
                >
                    <Stack
                        direction={'row'}
                        sx={{
                            position: 'relative',
                        }}
                    >
                        <Typography
                            level="body-lg"
                        >
                            {this.state.agent.title} :: {this.state.agent.short_title}
                        </Typography>
                        <CommonEditModal
                            overlay={true}
                            fields={
                                [
                                    'title',
                                    'short_title',
                                ]
                            }
                            baseUrl={'agent'}
                            obj={this.state.agent}
                            callBack={this.retrieveAgentNodes.bind(this)}
                        />
                    </Stack>
                    <CommonCallBackButton
                        icon={GetAppIcon}
                        label={'Экспорт'}
                        color={'primary'}
                        variant={'plain'}
                        callBack={this.export.bind(this)}
                    />
                </Stack>

                <form
                    onSubmit={this.onSubmit.bind(this)}
                >
                    <Stack
                        spacing={1}
                        sx={{
                            width: '100%'
                        }}
                    >
                        <Stack
                            spacing={1}
                            direction={'row'}
                            sx={{
                                width: '100%'
                            }}
                        >
                            <Stack
                                spacing={1}
                                sx={{
                                width: '50%'
                            }}
                            >
                                <Typography>
                                    Переменные запуска
                                </Typography>
                                <CommonJSONField
                                    defaultValue={this.state.agent.run_variables}
                                    name={'run_variables'}
                                    rows={20}
                                />
                            </Stack>
                            <Stack
                                spacing={1}
                                sx={{
                                    width: '50%'
                                }}
                            >
                                <Typography>
                                    Пространство имен
                                </Typography>
                                <CommonJSONField
                                    defaultValue={this.state.agent.result_variables}
                                    name={'result_variables'}
                                    rows={20}
                                />
                            </Stack>
                        </Stack>
                        <Button
                            type="submit"
                            sx={{
                                width: '100%'
                            }}
                        >
                            Сохранить
                        </Button>
                    </Stack>
                </form>
                <Box
                    sx={{
                        mt: 2,
                        width: '100%',
                        height: 800,
                        border: 2,
                        borderColor: '#FFF',
                    }}
                >
                    <ReactFlow
                        nodes={this.state.nodes}
                        edges={this.state.edges}
                        onNodesChange={this.onNodesChange.bind(this)}
                        onEdgesChange={this.onEdgesChange.bind(this)}
                        fitView
                        nodeTypes={nodeTypes}
                        edgeTypes={edgeTypes}
                    >
                        <Background />
                        <MiniMap
                            pannable={true}
                        />
                        <Controls/>
                    </ReactFlow>
                </Box>
            </Stack>
        )
    }
}

export default withRouter(AgentDetail);
